import gql from 'graphql-tag';

export default gql`
  query GetAllGuests($searchTerm: String, $status: StakeholderStatus) {
    stakeholders(
      orderBy: updatedAt_DESC
      where: {
        role: GUEST
        status: $status
        OR: [
          { firstName_contains: $searchTerm }
          { lastName_contains: $searchTerm }
          { email_contains: $searchTerm }
          { cellNumber_contains: $searchTerm }
          { residentialAddress_contains: $searchTerm }
        ]
      }
    ) {
      createdAt
      id
      updatedAt
      firstName
      lastName
      dob
      cellNumber
      email
      residentialAddress
      status
      role
      passes {
        id
        name
        validFrom
        validTo
        type
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/GetAllGuests.ts